import { render, staticRenderFns } from "./ProjectDeleteButton.vue?vue&type=template&id=0b0795fe&scoped=true&"
import script from "./ProjectDeleteButton.vue?vue&type=script&lang=ts&"
export * from "./ProjectDeleteButton.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectDeleteButton.vue?vue&type=style&index=0&id=0b0795fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b0795fe",
  null
  
)

export default component.exports